import { gradients } from '@juvare/common-web-ui/ColorPaper';
import { useAttachmentDataUrl } from '@juvare/platform-sdk-react/ui/hooks';
import { Avatar, Box, Typography } from '@mui/material';
import React from 'react';
import { resolveOrgInitialsForAvatar } from '../utils/resolveOrgInitialsForAvatar';
export const AccountMembershipOrgAvatar = ({ hasLogo, organizationId, organizationName }) => {
    const { data: attachmentUrl, isLoading, error } = useAttachmentDataUrl('organization', hasLogo ? organizationId : undefined, 'logo');
    return (React.createElement(Box, { sx: { display: 'flex', gap: 2, alignItems: 'center' } },
        React.createElement(Avatar, { alt: 'organization avatar', sx: {
                width: 40,
                height: 40,
                backgroundColor: gradients['orange-base'],
            }, src: attachmentUrl && !isLoading && !error ? attachmentUrl : undefined, "data-test": 'organization-avatar' },
            React.createElement(Typography, { variant: 'h6' }, resolveOrgInitialsForAvatar(organizationName)))));
};
